export const MUNDIAL_EVENTS = {
  SELECT_CONTENT: 'select_content',
  SCROLL: 'scroll',
  VIEW_ITEM: 'view_item',
  CONTENT_PLAY: 'content_play',
};

export const PAGE_TITLE_BASE = 'node/mundial2026';

export const CONTENT_SECTION = 'zona futbol';
export const CONTENT_TYPE = 'mundial';
export const CONTENT_CATEGORY = 'deportes';
export const AUTHPN = 'amco';

export const INTERACTION_TYPES = {
  PHASE_TABS: 'seleccion de fases',
  GROUP_TABS: 'seleccion de grupos',
  SIDE_ARROWS: 'flechas laterales',
  CARD_SELECT: 'seleccion de partido',
  SCROLL: 'scroll',
  MAIN_TABS: 'seleccion de seccion',
  VIEW_FULL_TOP: 'ver top completo',
  AUDIO_TOGGLE: 'boton de audio',
  GO_TO_CHANNEL: 'ir al canal',
};

export const SCROLL_DIRECTIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const SCROLL_THRESHOLDS = [25, 50, 75, 100];

/**
 * Lista de selectores CSS que delimitan los contenedores scrolleables
 * del modo Mundial. El useMundialScrollTracker resuelve el primer match
 * encontrado en el DOM en este orden de prioridad y observa SU scroll.
 *
 * Cuando el contenedor activo cambia (por ejemplo, al abrir un overlay),
 * los thresholds 25/50/75/100% se reinician.
 */
export const ALWAYS_RESET_SCROLL_SELECTORS = [
  '.content_div',
  '[data-role="mundial2026-tabpanel"]',
  '[data-role="wc-statistics-sections"]',
  '[data-role="wc-country-detail"]',
];
